import {createContext, useContext, useEffect, useReducer, useState} from "react";


const DateRangeContext = createContext({
    dates: [new Date(), new Date(new Date().setDate(new Date().getDate()-7))],
    setDateRange: () => Promise.resolve(),
});


function DateRangeProvider({children}) {
    const [dates, setDates] = useState([new Date(), new Date(new Date().setDate(new Date().getDate()-7))]);
    console.log("Date Provider Initialized");
    useEffect(() => {
        // If Cookie Exists...
        let selectedDate = window.localStorage.getItem("SelectedDates");
        if(selectedDate){
            selectedDate = JSON.parse(selectedDate);
            setDates([new Date(selectedDate[0]), new Date(selectedDate[1])])
        }else{
            const end = new Date();
            end.setDate(end.getDate() - 7);
            setDates([new Date(), end]);
        }

    }, []);

    const setDateRange = (start, end) => {
        setDates([start, end])
        window.localStorage.setItem("SelectedDates", JSON.stringify([start.toISOString(),end.toISOString()]));
    };


    return (
        <DateRangeContext.Provider
            value={{
                dates,
                setDateRange
            }}
        >
            {children}
        </DateRangeContext.Provider>
    );
}

export {DateRangeProvider, DateRangeContext};